import { render, staticRenderFns } from "./IosPrivDownMobile.vue?vue&type=template&id=17046f32&scoped=true&"
import script from "./IosPrivDownMobile.vue?vue&type=script&lang=js&"
export * from "./IosPrivDownMobile.vue?vue&type=script&lang=js&"
import style0 from "./IosPrivDownMobile.vue?vue&type=style&index=0&id=17046f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17046f32",
  null
  
)

export default component.exports